export default __webpack_public_path__ + "static/media/SUDIO.ef811573.svg";